import { ReactElement} from "react";
import icon1 from "../../assets/images&icons/Icon1.png";
import icon2 from "../../assets/images&icons/Icon2.png";
import icon3 from "../../assets/images&icons/Icon3.png";
import "./AboutUs.css";
import GeneralLayoutWithDots from "./components/GeneralLayoutWithDots";


export default function AboutUs(): ReactElement {
  return (
      <div className="w-full">

        <GeneralLayoutWithDots
          subTitle="More About WSG"
          CurrentPage="AboutUs"
        >
          <>
            {/* Main Content Section */}
            <div className="about-us-page-content py-4 xxs:py-5 xs:py-6 sm:py-8 md:py-10 lg:py-[40px]">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 xs:gap-5 sm:gap-6 lg:gap-8 mb-4 xs:mb-5 sm:mb-6 md:mb-8">
                {/* Video Section */}
                <div className="about-content px-2 xs:px-3 sm:px-4 lg:px-0 order-1 md:order-1 lg:order-1">
                  <div 
                    className="mb-4 relative shadow-lg"
                    style={{ padding: "56.25% 0 0 0", position: "relative", boxShadow: "10px 10px 10px -5px #999999" }}
                  >
                    <iframe 
                      src="https://player.vimeo.com/video/676062507?h=0a619de3f3&badge=0&autopause=0&player_id=0&app_id=58479" 
                      frameBorder="0" 
                      allow="autoplay; fullscreen; picture-in-picture" 
                      allowFullScreen
                      style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
                      title="wsg"
                    />
                  </div>
                </div>

                {/* Text Content Section */}
                <div 
                  className="about-content bg-no-repeat bg-right-top px-2 xs:px-3 sm:px-4 md:pl-6 lg:pl-8 order-2 md:order-2 lg:order-2"
                >
                  <p className="lead">
                    World Services Group is the most prominent global network of independent firms that provides an exclusive setting and platform to connect its members to the most elite legal firms and their multinational clients worldwide. Additionally, WSG provides cross industry access to a select few investment banking and accounting firms creating more expansive opportunities to service clients.
                  </p>
                  <p className="lead">
                    Through seamless collaboration and continual innovation, WSG delivers authentic association of global expertise with highest quality and value for clients.
                  </p>

                </div>
                <div className="flex flex-row gap-x-2 xs:gap-x-3 col-start-1 md:col-start-1 lg:col-start-2 px-2 xs:px-3 sm:px-4 md:pl-6 lg:pl-8 order-3 md:order-3 lg:order-3">
                    {Array.from({ length: 3 }, (_, i) => (
                      <div
                        key={i}
                        className="bg-[#bc3323] rounded-full w-4 h-4 xs:w-5 xs:h-5 sm:w-6 sm:h-6"
                      ></div>
                    ))}
                  </div>
              </div>

              <hr className="my-4 xs:my-5 sm:my-6 md:my-8 border-gray-300" />

              {/* Distinguished Select Membership Section */}
              <div className="mb-6 xs:mb-7 sm:mb-8 md:mb-10 lg:mb-12">
                <h3 className="title-icon">
                  <span className="mr-2 xs:mr-3 sm:mr-4">
                    <img src={icon1} alt="Distinguished Select Membership" className="w-12 h-12 xs:w-14 xs:h-14 sm:w-16 sm:h-16" />
                  </span>
                  <span>
                    Distinguished Select Membership
                  </span>
                </h3>
                <p className="lead">
                  World Services Group is comprised of over 120 prominent firms representing multinational clients worldwide. Members act in over 150 jurisdictions with over 23,000 professionals globally.
                </p>
                <p className="lead">
                  WSG members have an established record of standing and client success. Only firms of the highest quality principles, recognized expertise and excellent client service are given the opportunity to be considered. Firm membership is subject to review across multiple leadership channels and is selected based on strict objective standards established by the Board of Directors including:
                </p>
                <ul className="lead list-disc space-y-2">
                  <li>Having unparalleled depth of practical experience, knowledge and expertise with proven success</li>
                  <li>Having the highest professional reputation within the industry</li>
                  <li>Being considered among leading national, regional and/or international firms</li>
                </ul>
              </div>

              {/* Proprietary Solutions Platform Section */}
              <div className="mb-6 xs:mb-7 sm:mb-8 md:mb-10 lg:mb-12">
                <h3 className="title-icon">
                  <span className="mr-2 xs:mr-3 sm:mr-4">
                    <img src={icon2} alt="Proprietary Solutions Platform" className="w-12 h-12 xs:w-14 xs:h-14 sm:w-16 sm:h-16" />
                  </span>
                  <span>
                    Proprietary Solutions Platform
                  </span>
                </h3>
                <p className="lead">
                  The WSG proprietary solutions platform harnesses the strength of the network and the power of technology to help members stay competitive and exceed client expectations in rapidly changing environments. The platform is built exclusively by and for WSG members allowing for ease of adaptability to industry and client needs.
                </p>
                <p className="lead">
                  This exclusive approach enables global expertise powered by seamless collaboration and innovation to compete today and into the future.
                </p>
              </div>

              {/* Collaboration Across Industries Section */}
              <div className="mb-0">
                <h3 className="title-icon">
                  <span className="mr-2 xs:mr-3 sm:mr-4">
                    <img src={icon3} alt="Collaboration Across Industries" className="w-12 h-12 xs:w-14 xs:h-14 sm:w-16 sm:h-16" />
                  </span>
                  <span>
                    Collaboration Across Industries
                  </span>
                </h3>
                <p className="lead">
                  WSG expands the traditional approach to legal networks by extending cross industry access to a select few investment banking and accounting firms enabling untapped opportunities from key collaborators globally.
                </p>
              </div>
            </div>
          </>
        </GeneralLayoutWithDots>
      </div>

  );
}
